import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {Coupon} from "./dtos/coupon";
import {CouponListPage} from "./dtos/coupon-list-page";
import {CartLine} from "@app/core/cart/domain/dtos/cart-line";

@Injectable({
    providedIn: 'root'
})
export abstract class CouponRemote {
    public abstract validateCouponByReference(couponCode: string, cart: CartLine[], recaptchaToken: string): Observable<Coupon>;
    public abstract getAvailableCoupons(itemsPerPage: number, page: number): Observable<CouponListPage>;
    public abstract getUsedCoupons(itemsPerPage: number, page: number): Observable<CouponListPage>;
    public abstract getAccumulatedAmount(): Observable<number>;
}
